import {Map, fromJS, List} from "immutable";

import {
    FETCH_DOCUMENTATION_REQUEST,
    FETCH_DOCUMENTATION_SUCCESS,
    FETCH_DOCUMENTATION_ERROR,
    DELETE_DOCUMENTATION_REQUEST,
    DELETE_DOCUMENTATION_SUCCESS,
    DELETE_DOCUMENTATION_ERROR,
    CREATE_DOCUMENTATION_REQUEST,
    CREATE_DOCUMENTATION_SUCCESS,
    CREATE_DOCUMENTATION_ERROR,
    UPDATE_DOCUMENTATION_REQUEST,
    UPDATE_DOCUMENTATION_SUCCESS,
    UPDATE_DOCUMENTATION_ERROR
} from "./documentation-actions";

const documentation = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false,
    created: false,
    updated: false,
    deleted: false
}), action) => {
    let newState;
    let updatedPayload, index, payload = state.get("payload");
    switch (action.type) {

        // Requests
        case FETCH_DOCUMENTATION_REQUEST:
        case DELETE_DOCUMENTATION_REQUEST:
        case CREATE_DOCUMENTATION_REQUEST:
        case UPDATE_DOCUMENTATION_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false,
                created: false,
                updated: false,
                deleted: false
            });
            return newState;

        // Success
        case FETCH_DOCUMENTATION_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false,
                created: false,
                updated: false,
                deleted: false
            });
            return newState;

        case CREATE_DOCUMENTATION_SUCCESS:
            if (List.isList(state.get("payload"))) {
                let updatedPayload = state.get("payload");
                updatedPayload = updatedPayload.push(fromJS(action.payload));

                newState = state.merge({
                    payload: updatedPayload,
                    isFetching: false,
                    error: false,
                    created: action.payload._id,
                    updated: false,
                    deleted: false
                });
            } else {
                newState = state.merge({
                    payload: fromJS(action.payload),
                    isFetching: false,
                    error: false,
                    created: action.payload._id,
                    updated: false,
                    deleted: false
                });
            }
            return newState;
        case UPDATE_DOCUMENTATION_SUCCESS:
            // Check if payload is a List
            if (List.isList(state.get("payload"))) {

                // Find the index of the documentation to be updated inside the List
                index = payload.findIndex(item => {
                    return item.get('_id') === action.payload._id;
                });

                // Update the payload list
                if (index !== -1) {
                    updatedPayload = payload.update(index, () => {
                       return fromJS(action.payload);
                    });
                }

            } else {
                updatedPayload = fromJS(action.payload);
            }
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                payload: updatedPayload,
                created: false,
                updated: action.payload._id,
                deleted: false
            });
            return newState;           

        case DELETE_DOCUMENTATION_SUCCESS:
            updatedPayload = state.get('payload').filter( client => {
                return client.get('_id') !== action.payload._id;
            });
            newState = state.merge({
                payload: updatedPayload,
                isFetching: action.isFetching,
                error: action.error,
                created: false,
                updated: false,
                deleted: action.payload._id
            });
            return newState;

        // Errors
        case FETCH_DOCUMENTATION_ERROR:
        case DELETE_DOCUMENTATION_ERROR:
        case CREATE_DOCUMENTATION_ERROR:
        case UPDATE_DOCUMENTATION_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage,
                created: false,
                updated: false,
                deleted: false
            });
        default:
            return state;
    }
};

export default documentation;